import * as Styles from './_styles/full-width-nav-bar.styled'
import {NavBarLinks} from './nav-bar-links'
import {Logo} from './logo'
import {Logout} from './logout'
import {ToggleProvider} from '../../../../contexts/toggle/toggle-provider'

import type {JSX} from 'react'

export function FullWidthNavBar(): JSX.Element {
    return (
        <Styles.NavigationBar id="fullwidth-navigation">
            <Styles.Content>
                <Logo />
                <ToggleProvider>
                    <NavBarLinks />
                </ToggleProvider>
                <Logout />
            </Styles.Content>
        </Styles.NavigationBar>
    )
}
